import { DateOnly, DateTime } from "../../../../@client/System"

export function getTimeString(timeStamp: string) {
  const date = new Date(timeStamp)
  const hours = date.getHours().toString().padStart(2, "0")
  const minutes = date.getMinutes().toString().padStart(2, "0")
  return `${hours}:${minutes}`
}

export function getDateString(timeStamp?: string) {
  const date = timeStamp ? new Date(timeStamp) : new Date()
  const year = date.getFullYear()
  const month = (date.getMonth() + 1).toString().padStart(2, "0")
  const day = date.getDate().toString().padStart(2, "0")
  return `${year}-${month}-${day}` as DateOnly
}

export function getDateTimeString(
  dateOnly: string,
  timeOnly: string
): DateTime {
  return `${dateOnly}T${timeOnly}:00` as DateTime
}
